/**
 * Parses API GraphQL errors and returns user-friendly error messages
 */

// Error code to user-friendly message mapping
const ERROR_MESSAGES: Record<string, string> = {
  "GQL_ERR.PAYMENTS.VERIFICATION_FAILED":
    "The MFA code you entered is invalid. Please check your authenticator app and try again.",
};

/**
 * Parses API error and returns a user-friendly message
 * @param err - The error object from API call
 * @param defaultMessage - Default message if no specific error is found
 * @returns User-friendly error message
 */
export const parseApiError = (
  err: any,
  defaultMessage: string = "Something went wrong. Please try again or contact support."
): string => {
  const errorCode = err?.response?.errors?.[0]?.extensions?.code;

  return ERROR_MESSAGES[errorCode] || defaultMessage;
};
